import { IonHeader } from '@ionic/react';
import OrderMethodToolbar from '../../../../../modals/order-method/OrderMethodToolbar';
import CupIcon from '../../../../../assets/icons/CupIcon';
import DiscountsIcon from '../../../../../assets/icons/DiscountsIcon';
import PlateIcon from '../../../../../assets/icons/PlateIcon';
import ProfileToolbar from '../../../../../components/tool-bars/ProfileToolbar';
import AuthButtons from '../AuthButtons/AuthButtons';
import { REDUX_STORE_SLICES } from '../../../../../../../services/exports/Constants';
import useAuth from '../../../../../../../hooks/global/useAuth';
import useStore from '../../../../../../../hooks/store/useStore';
import { useMemo } from 'react';
import { collect } from 'collect.js';
import RewardsToolbar from '../../../../rewards/RewardsToolbar';
import { useTranslation } from 'react-i18next';
import useMobileApp from '../../../../../../../hooks/mobile-app/useMobileApp';

const Header = (): JSX.Element => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Home:Components:Header' });
  const { company } = useStore<REDUX_STORE_SLICES.INITIAL_DATA>(REDUX_STORE_SLICES.INITIAL_DATA);
  const { isLoggedIn } = useAuth();
  const { insets } = useMobileApp();

  const image = useMemo(() => collect(company?.pictures).first(), [company]);

  const LoggedIn = (): JSX.Element => {
    return (
      <IonHeader className="h-fit ion-color w-full text-center relative">
        <div
          className="relative w-full rounded-b-[100px] mb-sm overflow-hidden"
          style={{
            height: insets.top + 215,
          }}
        >
          <img
            alt="Restaraunt image"
            src={image}
            className="absolute h-full inset-0 size-full object-cover opacity-70 order-last"
          />
          <div className="absolute inset-0 size-full bg-black/70" />
        </div>
        <div className="absolute inset-0 justify-between px-4 flex flex-col">
          <div className="safe-area-top w-full h-fit relative">
            <div className="py-sm w-full flex flex-col items-center relative">
              <OrderMethodToolbar className="bg-transparent py-none !backdrop-blur-none border-none">
                <OrderMethodToolbar.CompanyName className="text-white" />
                <OrderMethodToolbar.OrderMethodDetails className="text-white" />
              </OrderMethodToolbar>
              <div className="absolute right-0">
                <ProfileToolbar />
              </div>
            </div>
          </div>
          <RewardsToolbar className="!mt-sm" />
        </div>
      </IonHeader>
    );
  };

  const LoggedOut = (): JSX.Element => {
    return (
      <IonHeader className="h-fit ion-color w-full">
        <img
          alt="Restaraunt image"
          src={image}
          className="absolute h-full inset-0 size-full object-cover opacity-70 order-last"
        />
        <div className="absolute inset-0 size-full bg-black/70" />
        <div className="safe-area-top w-full">
          <div className="relative pt-sm pb-7 space-y-4 px-sm text-center">
            <OrderMethodToolbar>
              <OrderMethodToolbar.CompanyName />
              <OrderMethodToolbar.OrderMethodDetails />
            </OrderMethodToolbar>
            <div className="flex flex-col items-center space-y-2 max-w-5/6 mx-auto">
              <div className="flex justify-left items-center gap-x-4 w-fit">
                <CupIcon className="w-8 shrink-0 stroke-white" />
                <p className="text-sm text-white text-left font-medium">{t('benefits.earn_points')}</p>
              </div>
              <div className="flex justify-left items-center gap-x-4 w-fit">
                <PlateIcon className="w-8 shrink-0 stroke-white" />
                <p className="text-sm text-white text-left font-medium"> {t('benefits.redeem_points')}</p>
              </div>
              <div className="flex justify-left items-center gap-x-4 w-fit">
                <DiscountsIcon className="w-8 shrink-0 stroke-white" />
                <p className="text-sm text-white text-left font-medium"> {t('benefits.get_deals')}</p>
              </div>
            </div>
            <AuthButtons />
          </div>
        </div>
      </IonHeader>
    );
  };

  return isLoggedIn ? <LoggedIn /> : <LoggedOut />;
};

export default Header;
